module.exports = __webpack_public_path__ + "img/empnan.d2a317c8.png";